function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "logo_design");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M861.29534,490.50525l-9.73-8.18015.91324-1.08627.914.76846a3.49807,3.49807,0,0,1-.07528-1.54426,3.11622,3.11622,0,0,1,.71737-1.3979,3.63113,3.63113,0,0,1,1.8001-1.19986,3.71676,3.71676,0,0,1,2.18241.05989,6.2446,6.2446,0,0,1,2.14641,1.20535,6.14364,6.14364,0,0,1,1.61826,2.02184,3.81845,3.81845,0,0,1,.37806,2.23971,3.77516,3.77516,0,0,1-.84548,1.94024,2.9303,2.9303,0,0,1-1.151.8581,3.18639,3.18639,0,0,1-1.29016.24369l3.42438,2.87892Zm-5.26548-6.2695a3.99956,3.99956,0,0,0,2.46912,1.13751,2.20126,2.20126,0,0,0,1.76838-.78562,2.25215,2.25215,0,0,0,.472-1.92635,4.16682,4.16682,0,0,0-1.607-2.31761,4.05845,4.05845,0,0,0-2.47853-1.13977,2.17571,2.17571,0,0,0-1.7799.759,2.243,2.243,0,0,0-.42116,1.94651A4.1619,4.1619,0,0,0,856.02986,484.23575Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M864.27388,481.48946l-1.49562-5.64377-5.37711-.46208,1.25291-1.49031,2.55694.30693q.72687.09048,1.20027.17251-.19242-.65864-.3239-1.188l-.66575-2.58331,1.19723-1.42407,1.26813,5.21511,5.922.5132-1.23064,1.46381-3.39972-.39368-.91247-.11143,1.22166,4.18118Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 831.1562,
  y: 502.51486,
  width: 10,
  height: 10,
  transform: "translate(-235.89074 649.13171) rotate(-49.94575)",
  fill: "#3f3d56"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 841.45241,
  y: 490.26789,
  width: 10,
  height: 10,
  transform: "translate(-222.84601 652.6469) rotate(-49.94575)",
  fill: "#3f3d56"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M861.29534,490.50525l-9.73-8.18015.91324-1.08627.914.76846a3.49807,3.49807,0,0,1-.07528-1.54426,3.11622,3.11622,0,0,1,.71737-1.3979,3.63113,3.63113,0,0,1,1.8001-1.19986,3.71676,3.71676,0,0,1,2.18241.05989,6.2446,6.2446,0,0,1,2.14641,1.20535,6.14364,6.14364,0,0,1,1.61826,2.02184,3.81845,3.81845,0,0,1,.37806,2.23971,3.77516,3.77516,0,0,1-.84548,1.94024,2.9303,2.9303,0,0,1-1.151.8581,3.18639,3.18639,0,0,1-1.29016.24369l3.42438,2.87892Zm-5.26548-6.2695a3.99956,3.99956,0,0,0,2.46912,1.13751,2.20126,2.20126,0,0,0,1.76838-.78562,2.25215,2.25215,0,0,0,.472-1.92635,4.16682,4.16682,0,0,0-1.607-2.31761,4.05845,4.05845,0,0,0-2.47853-1.13977,2.17571,2.17571,0,0,0-1.7799.759,2.243,2.243,0,0,0-.42116,1.94651A4.1619,4.1619,0,0,0,856.02986,484.23575Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M864.27388,481.48946l-1.49562-5.64377-5.37711-.46208,1.25291-1.49031,2.55694.30693q.72687.09048,1.20027.17251-.19242-.65864-.3239-1.188l-.66575-2.58331,1.19723-1.42407,1.26813,5.21511,5.922.5132-1.23064,1.46381-3.39972-.39368-.91247-.11143,1.22166,4.18118Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 831.1562,
  y: 502.51486,
  width: 10,
  height: 10,
  transform: "translate(-235.89074 649.13171) rotate(-49.94575)",
  fill: "#3f3d56"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 841.45241,
  y: 490.26789,
  width: 10,
  height: 10,
  transform: "translate(-222.84601 652.6469) rotate(-49.94575)",
  fill: "#3f3d56"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  y: 554.37076,
  width: 909,
  height: 2,
  fill: "#3f3d56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 483.0696,
  cy: 82.41592,
  r: 11.40881,
  fill: "#f2f2f2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.74653,288.63694a22.03137,22.03137,0,0,0-14.30416-20.31043,22,22,0,1,0-15.93632.21325,21.9912,21.9912,0,0,0,.54858,40.99633,22,22,0,1,0,15.93632-.21325A22.03136,22.03136,0,0,0,347.74653,288.63694Zm-42.54482-40.43437a20,20,0,1,1,24.77122,19.13762,22.02329,22.02329,0,0,0-9.02507.12077A20.02093,20.02093,0,0,1,305.20171,248.20257ZM346.29529,329.66a20,20,0,1,1-24.77122-19.13762,22.02352,22.02352,0,0,0,9.02507-.12076A20.02093,20.02093,0,0,1,346.29529,329.66Zm-15.77378-21.32351a22.02329,22.02329,0,0,0-9.02507.12077,19.97883,19.97883,0,0,1-.521-38.93121,22.02352,22.02352,0,0,0,9.02507-.12076,19.97882,19.97882,0,0,1,.52095,38.9312Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#f2f2f2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "106.196 198.825 89.661 198.825 89.661 391.493 89.661 408.028 106.196 408.028 194.622 408.028 194.622 391.493 106.196 391.493 106.196 198.825",
  fill: "#6c63ff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M397.635,370.6398H381.1V579.843H486.06109V370.6398H397.635Zm71.89114,192.66827H397.635V387.17476h71.89114Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#6c63ff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M776.14185,370.99926H687.71574V580.20248H792.67681V370.99926Zm0,192.66826H704.25071V387.53422h71.89114Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#6c63ff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "468.887 303.427 455.227 303.427 455.227 319.962 468.887 319.962 468.887 391.853 396.996 391.853 396.996 215.72 485.422 215.72 485.422 199.185 396.996 199.185 380.461 199.185 380.461 215.72 380.461 391.853 380.461 408.388 396.996 408.388 468.887 408.388 485.422 408.388 485.422 391.853 485.422 319.962 499.081 319.962 499.081 303.427 485.422 303.427 468.887 303.427",
  fill: "#6c63ff"
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 150.88132,
  y: 180.21708,
  width: 5.3166,
  height: 1.7722,
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M715.2566,353.8039H704.37332v-1.7722H715.2566Zm-21.7657,0H682.60762v-1.7722H693.4909Zm-21.76656,0H660.84106v-1.7722h10.88328Zm-21.76657,0H639.07536v-1.7722h10.88241Zm-21.7657,0H617.30879v-1.7722h10.88328Zm-21.76656,0H595.54223v-1.7722h10.88328Zm-21.76657,0H573.77653v-1.7722h10.88241Zm-21.7657,0H552.01v-1.7722h10.88328Zm-21.76656,0H530.24339v-1.7722h10.88329Zm-21.7657,0H508.47769v-1.7722H519.361Zm-21.76657,0H486.71113v-1.7722h10.88328Zm-21.76613,0H464.945v-1.7722h10.88328Zm-21.76657,0H443.17886v-1.7722h10.88285Zm-21.76613,0H421.4123v-1.7722h10.88328Zm-21.76613,0H399.64617v-1.7722h10.88328Zm-21.76657,0H377.88v-1.7722h10.88285Zm-21.76613,0H356.1139v-1.7722h10.88285Zm-21.76613,0H334.34734v-1.7722h10.88328Zm-21.76613,0H312.5812v-1.7722h10.88329Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 580.63989,
  y: 180.21708,
  width: 5.3166,
  height: 1.7722,
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 664.15482,
  y: 226.29429,
  width: 1.7722,
  height: 5.3166,
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M811.427,536.34053h-1.77221V525.26428H811.427Zm0-22.15251h-1.77221V503.11177H811.427Zm0-22.1525h-1.77221V480.95927H811.427Zm0-22.1525h-1.77221V458.80676H811.427Zm0-22.15251h-1.77221V436.65426H811.427Zm0-22.1525h-1.77221V414.50176H811.427Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 664.15482,
  y: 375.60216,
  width: 1.7722,
  height: 5.3166,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 89.07583,
  y: 119.29769,
  width: 1.7722,
  height: 368.61766,
  fill: "#f2f2f2"
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 646.43282,
  y: 119.07617,
  width: 1.7722,
  height: 368.61766,
  fill: "#f2f2f2"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.68735,
  y: 407.05871,
  width: 735.46312,
  height: 1.7722,
  fill: "#f2f2f2"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.46582,
  y: 197.93908,
  width: 735.46312,
  height: 1.7722,
  fill: "#f2f2f2"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M937.551,282.3004a7.791,7.791,0,0,1-.68563,3.63514,8.10036,8.10036,0,0,1-2.76586,2.584l-8.07737,5.448c-2.382,1.60661-5.075,4.454-3.54711,6.88723a5.25157,5.25157,0,0,0,2.30442,1.74407c8.2728,3.97138,17.7154,4.72684,26.8909,4.58055,5.85156-.09329,11.97151-.61138,16.92617-3.726,2.3582-1.48242,4.39441-3.52233,6.98311-4.55058,1.79148-.71158,4.12-1.23158,4.57889-3.10378.62195-2.53722-2.71811-3.94328-5.129-4.94918-5.15981-2.1528-8.74341-7.12818-10.42263-12.461s-1.69093-11.03722-1.42678-16.62189a3.03715,3.03715,0,0,0-.514-2.29921,2.95553,2.95553,0,0,0-1.89659-.66618,100.22926,100.22926,0,0,0-16.73428-.28224,11.6941,11.6941,0,0,0-5.9214,1.54123c-3.39329,2.32433-1.468,6.26373-1.10928,9.53486A98.84649,98.84649,0,0,1,937.551,282.3004Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#9f616a"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M972.49315,171.81462a19.36916,19.36916,0,0,1-12.01375,6.29292c-8.00917,1.14417-1.71625,13.73-1.71625,13.73s-2.28834-4.57667,2.28833-8.58125S972.49315,176.96337,972.49315,171.81462Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref30 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 811.5516,
  cy: 22.65453,
  r: 9.87505,
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M968.58039,204.19287c-7.62894-3.98478-20.753-7.11888-27.726-6.89485l1.764-6.74373c6.17311,4.194,19.22821,7.38661,27.726,6.89485Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#6c63ff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 801.09567,
  cy: 60.41208,
  r: 35.43401,
  fill: "#2f2e41"
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 774.08449,
  y: 503.91811,
  width: 16.26479,
  height: 27.8825,
  fill: "#9f616a"
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 821.13621,
  y: 503.91811,
  width: 16.26479,
  height: 27.8825,
  fill: "#9f616a"
});

var _ref35 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "770.018 215.218 762.142 241.501 842.048 243.101 835.658 215.218 814.746 201.277 770.018 215.218",
  fill: "#9f616a"
});

var _ref36 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 797.9008,
  cy: 75.80555,
  r: 25.55896,
  fill: "#9f616a"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M896.59883,353.0981a36.20181,36.20181,0,0,0-2.56507,14.31334c.22572,5.677,1.99431,12.93714.8925,17.86184-4.26264,19.0516-10.58409,47.34065-22.01236,62.76867-2.68315,3.62214-7.931,5.6186-11.91042,8.36241s-7.76717,5.74319-9.92387,10.59875c-1.6776,3.77681-1.62107,8.36121-1.49314,12.648.07056,2.3645.29956,5.06461,2.34943,6.6242a2.24686,2.24686,0,0,0,1.37239-2.18321c.10145-.97191-.09212-1.96335.07406-2.96593a6.06372,6.06372,0,0,1,3.2129-4.12214c9.33268-5.76741,19.31794-10.80044,24.26333-20.83943s8.6965-18.99315,15.39288-27.83457a73.97465,73.97465,0,0,0,5.26231-7.01845,54.80025,54.80025,0,0,0,5.81214-14.30226c2.73668-10.51381,3.97168-21.58373,4.80675-32.30866.42676-5.48129.39682-11.35236-3.76357-14.896C904.52093,356.52692,899.83605,356.9417,896.59883,353.0981Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#9f616a"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1012.12943,340.7997a41.39471,41.39471,0,0,1,1.32692,14.857c-.56138,6.04641-2.4557,12.06952-1.6047,18.082,3.29212,23.25967-.29862,47.32385,1.55111,70.74241.43427,5.49816,2.20242,11.58274,2.5169,17.089s-.32377,11.25085-3.12616,16.00111c-2.17978,3.6949-5.51225,6.5437-8.78269,9.32-1.80389,1.53134-4.1797,3.15983-6.33891,2.19191a2.22886,2.22886,0,0,1,.56216-2.56739c.64437-.68882,1.4942-1.17076,2.08707-1.90437,1.144-1.41554,1.09651-3.421.96843-5.23648-.76085-10.78453-2.34678-21.84128.59743-32.244,2.93542-10.37169,1.13227-21.69749-1.85924-32.05313-.79958-2.76788-1.84147-5.46495-2.53668-8.26087-1.20575-4.84909-1.345-9.8907-1.47822-14.88568l-.82176-30.81868c-.14-5.25026.18055-11.44172,4.55783-14.34417C1003.79767,344.08383,1008.94256,344.46622,1012.12943,340.7997Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#9f616a"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M987.53537,403.53464c-5.22,2.84444-10.49748,5.7125-16.22642,7.29957-5.998,1.6616-12.28942,1.86374-18.51035,2.05561a46.42549,46.42549,0,0,1-21.84192-3.09094L908.368,402.08876c-15.98045,38.37584-22.26133,80.89908-13.58941,121.55468,3.15734,14.80223-.15009,30.13454-.1442,45.26975a149.29508,149.29508,0,0,0,.58413,16.07321c.44774,4.12145,1.238,8.19795,1.7801,12.308,3.30222,25.03583-2.657,50.65338,1.063,75.63056.51081,3.42972,4.66948,5.32748,7.97675,6.36953a32.55915,32.55915,0,0,0,5.09454,1.02534c8.75838,1.28179,17.619,2.56673,26.43057,1.72511,2.15263-.2056,4.70453-.86664,5.35915-2.92759.522-1.64337-.42885-3.60854.46743-5.08157,5.72149-9.40319,1.45865-22.28716,2.04639-33.27852,1.55479-29.076-.34659-58.30364,2.33608-87.29734.5135-5.54978-.21852-10.44942.2842-16.00019l.34147-3.77027,1.03725-11.45263c.61925,15.96363,1.28558,31.5446,1.90483,47.50823.18007,4.642.37014,9.34519,1.73157,13.78668.72067,2.35108,1.76245,4.60138,2.35376,6.98828a38.56724,38.56724,0,0,1,.83479,7.849l2.642,70.32692a57.50059,57.50059,0,0,1-.53874,7.56454c-.25874,2.87741-.31167,6.26756,1.95235,8.06217a7.46421,7.46421,0,0,0,4.00335,1.30431c4.30841.404,8.63147-.35783,12.89173-1.11666,4.31169-.768,13.27046-1.536,17.58215-2.304a6.66225,6.66225,0,0,0,1.88953-.53325c1.94456-.99478,2.42555-3.56913,2.24174-5.74562s-.78684-4.41954-.11362-6.49744c8.72873-26.94124-1.86756-56.52159.09844-84.77324,1.75079-25.159,1.50421-50.40932,1.25675-75.628-.14635-14.91357-1.15463-29.50111-.84312-44.41215.37955-18.16783,1.73287-37.19742-5.96511-53.65813C991.99872,408.05243,990.23638,405.266,987.53537,403.53464Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938.17283,693.15929s-16.84568-8.1324-19.75011,0-8.71328,27.30161-2.32354,31.9487h0a14.8062,14.8062,0,0,0,14.49492,1.671c4.12693-1.75461,8.16781-3.96995,7.57872-5.73723C937.01106,717.55648,938.17283,693.15929,938.17283,693.15929Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M964.31267,693.15929s16.84568-8.1324,19.75011,0,8.71328,27.30161,2.32354,31.9487h0a14.8062,14.8062,0,0,1-14.49492,1.671c-4.12693-1.75461-8.16781-3.96995-7.57872-5.73723C965.47444,717.55648,964.31267,693.15929,964.31267,693.15929Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M985.18328,295.34439a655.1896,655.1896,0,0,0-72.95995,2.77122,13.66316,13.66316,0,0,0-5.22793,1.20946,12.66639,12.66639,0,0,0-3.55367,3.21557A77.59469,77.59469,0,0,0,885.5379,348.7287c-.09207,2.18971-.00709,4.6127,1.47642,6.22594,6.72318,7.31112,15.246,12.64749,20.57357,21.03028a32.95412,32.95412,0,0,0,4.4602,6.28706,65.4254,65.4254,0,0,0-.43474,18.11811c3.52962-4.61586,8.80873-7.64786,14.33348-9.44827s11.34358-2.47145,17.11654-3.13272c8.42419-.965,17.44034-1.82793,24.9464,2.11633,5.89119,3.09569,10.1829,8.86284,16.37858,11.29244a115.67988,115.67988,0,0,0,1.44775-15.69363c.1752-7.36312,5.7019-12.79989,8.61438-19.56477a37.0684,37.0684,0,0,1,2.882-5.75167c2.94876-4.496,7.75411-7.51865,12.82838-9.29653s10.46248-2.42874,15.801-3.06833c2.42828-3.41649,1.64667-7.78562-.04144-11.62218s-4.50663-7.0395-6.94664-10.44763c-4.73841-6.61846-8.14218-14.16674-13.34966-20.42284A26.7444,26.7444,0,0,0,985.18328,295.34439Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.73608,207.53688S941.7144,222.99333,917.671,226.42809s-5.15214,41.21719-5.15214,41.21719-6.86954-13.73906,6.86953-25.76074S953.73608,222.99333,953.73608,207.53688Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.73608,207.53688s6.86953,24.04336,17.17383,27.47813,5.15215,39.49981-12.02168,42.93457c0,0,14.59775-19.7499,6.01084-35.20635S951.16,215.2651,953.73608,207.53688Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.73608,207.53688S941.7144,222.99333,917.671,226.42809s-5.15214,41.21719-5.15214,41.21719-6.86954-13.73906,6.86953-25.76074S953.73608,222.99333,953.73608,207.53688Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.73608,207.53688s6.86953,24.04336,17.17383,27.47813,5.15215,39.49981-12.02168,42.93457c0,0,14.59775-19.7499,6.01084-35.20635S951.16,215.2651,953.73608,207.53688Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#2f2e41"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M530.30789,338.2965V325.58477H531.727v1.19416a3.49811,3.49811,0,0,1,1.13359-1.05138,3.11624,3.11624,0,0,1,1.53164-.35046,3.63108,3.63108,0,0,1,2.07679.60573,3.71678,3.71678,0,0,1,1.35857,1.709,6.2446,6.2446,0,0,1,.45863,2.41861,6.1436,6.1436,0,0,1-.50622,2.53975,3.81851,3.81851,0,0,1-1.47106,1.73066,3.77519,3.77519,0,0,1-2.02921.60141,2.93033,2.93033,0,0,1-1.39751-.32883,3.18628,3.18628,0,0,1-1.01676-.83072v4.47377Zm1.41049-8.0649a3.99966,3.99966,0,0,0,.71822,2.622,2.20128,2.20128,0,0,0,1.73932.848,2.25213,2.25213,0,0,0,1.77826-.87831,4.16684,4.16684,0,0,0,.73986-2.72147,4.05844,4.05844,0,0,0-.72255-2.63061,2.17569,2.17569,0,0,0-1.72634-.874,2.243,2.243,0,0,0-1.76095.93023A4.16191,4.16191,0,0,0,531.71838,330.2316Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M539.12562,334.7746l3.35749-4.77664-3.10654-4.41319h1.947l1.41049,2.15468q.39848.6146.64034,1.02974.38032-.57112.70092-1.01244l1.54895-2.172h1.86046l-3.17577,4.32666,3.41806,4.86317h-1.91238l-1.88642-2.8556-.5019-.77015-2.41427,3.62575Z",
  transform: "translate(-145.5 -171.81462)",
  fill: "#3f3d56"
});

var _ref49 =
/*#__PURE__*/
React.createElement("rect", {
  x: 334.61078,
  y: 153.18538,
  width: 10,
  height: 10,
  fill: "#3f3d56"
});

var _ref50 =
/*#__PURE__*/
React.createElement("rect", {
  x: 350.61078,
  y: 153.18538,
  width: 10,
  height: 10,
  fill: "#3f3d56"
});

var _ref51 =
/*#__PURE__*/
React.createElement("rect", {
  x: 366.61078,
  y: 153.18538,
  width: 10,
  height: 10,
  fill: "#3f3d56"
});

var SvgDefault = function SvgDefault(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "ab9c9524-e61a-4262-9078-30d20f864b6e",
    "data-name": "Layer 1",
    width: 909,
    height: 556.37076,
    viewBox: "0 0 909 556.37076",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default.2bfe0242.svg";
export { ForwardRef as ReactComponent };